import { setupStorageTokensConfig } from './storage-tokens-config';

setupStorageTokensConfig({
    heartBeat: global?.StorageTokensConfig?.heartBeat || 5000,
    runOnce: global?.StorageTokensConfig?.runOnce || false,
    showLogs: global?.StorageTokensConfig?.showLogs || false,
});
